// extracted by mini-css-extract-plugin
export var grid = "_4-5";
export var layout = "_4-0";
export var leftColumn = "_4-1";
export var leftInner = "_4-2";
export var rightColumn = "_4-3";
export var rightInner = "_4-4";